import HHUI from './ui'
import HHServer from './server'

export default window.HH = new class {
	constructor() {
		this.player = 0;
		this.settings = null;
	}

	async bestMove() {
		HHUI.loadingStart();
		await this._machineStep();
		HHUI.loadingEnd();
	}

	async break() {
		HHUI.loadingStart();
		try {
			await HHServer.breakParty(this.player);
			return true;
		} catch (e) {
			this.handleError(e);
		} finally {
			HHUI.loadingEnd();
		}
	}

	isMachine(player) {
		if (this.settings.mode == 'TABLET') return false;
		const i = player - 1;
		return this.settings.mode.split('-')[i][0] == 'M';
	}

	handleError(e) {
		e = e.message ? e.message : (e || "").toString();
		const invalidMove = e.includes("place stone") && e.includes("invalid");
		const invalidRevoke = e.includes("not enough moves to remove some");
		if (invalidMove || invalidRevoke) {
			// NOP?
		} else {
			HHUI.loadingEnd();
			HHUI.error(e);
			throw new Error('Unrecoverable error: ' + e);
		}
	}

	async humanStep(gpv) {
		HHUI.loadingStart();
		let r;
		try {
			r = await HHServer.placeStone({
				pid: this.player,
				x: gpv[0],
				y: gpv[1],
				d: gpv[2],
				p: gpv[3]
			});
		} catch (e) {
			this.handleError(e);
		}
		await this._postMove(r);
		HHUI.loadingEnd();
	}

	async newGame(settings) {
		HHUI.loadingStart();
		await this._newGame(settings);
		HHUI.loadingEnd();
	}

	async restartGame() {
		HHUI.loadingStart();
		try {
			const s = await HHServer.breakParty(this.player);
			if (s) {
				await this._newGame();
			}
		} catch (e) {
			this.handleError(e);
		}
		HHUI.loadingEnd();
	}

	async revokeMove() {
		HHUI.loadingStart();
		let r;
		try {
			r = await HHServer.revokeLastMove(this.player);
		} catch (e) {
			this.handleError(e);
		}
		await this._postMove(r, true);
		HHUI.loadingEnd();
	}

	// Lower-level functions below
	// - should not call HHUI.loadingX()
	// - should handle server errors
	// - shoult not be called from HHUI

	async _machineStep() {
		let r;
		try {
			r = await HHServer.processMove(this.player);
		} catch (e) {
			this.handleError(e);
		}
		await this._postMove(r);
	}

	async _newGame(settings) {
		try {
			if (settings) {
				this.settings = settings;
				await HHServer.changeSetting(this.settings);
			}
			await HHServer.startGame();
			HHUI.displayBoard();
			this.player = 1;
			if (this.isMachine(this.player)) {
				await this._machineStep();
			} else {
				HHUI.initiatePlayerTurn(this.player);
			}
		} catch (e) {
			this.handleError(e);
		}
	}

	async _postMove(r, keepPlayer) {
		if (r && r.success) {
			HHUI.updateBoard(r.move, r.remove, r.conflicts, r.partyTurn);
		}
		if (r && r.playerCanChange && !keepPlayer) {
			this.player = this.player == 1 ? 2 : 1;
		}
		if (r && r.winner) {
			try {
				await HHServer.breakParty(this.player);
				this.player = 0;
				HHUI.gameOver(r.winner);
			} catch (e) {
				this.handleError(e);
			}
		}
		if (this.player > 0) {
			if (this.isMachine(this.player)) {
				await this._machineStep();
			} else {
				HHUI.initiatePlayerTurn(this.player);
			}
		}
	}
}
